 import React, { useEffect } from 'react'
 import about1 from '../../img/50-easy-ways-to-eat-more-fruit-and-veg-iStock-1225383160-removebg-preview.png'
 import about2 from '../../img/product-1.png'
 import { Link } from 'react-router-dom'
 import Aos from 'aos'
 import 'aos/dist/aos.css'
 export default function About() {
    useEffect(() => {
        Aos.init({
            duration: 1000
        })

    }, [])

   return <>

<div className="container-fluid bg-primary py-5 bg-hero mb-5">
  <div className="container py-5">
    <div className="row justify-content-start">
      <div className="col-lg-8 text-center text-lg-start">
        <h1 className="display-1 text-white mb-md-4">About Us</h1>
        <Link to="/" className="btn btn-primary py-md-3 px-md-5 me-3">Home</Link>
        <Link  className="btn btn-secondary py-md-3 px-md-5">About Us</Link>
      </div>
    </div>
  </div>
</div>

            {/* About Start */}
            <div className="container-fluid about pt-5">
            <div className="container">
                <div className="row gx-5">
                    <div className="col-lg-6 mb-5 mb-lg-0">
                        <div className="d-flex h-100 border border-5 border-primary border-bottom-0 pt-4">
                            <img className="img-fluid mt-auto mx-auto" src={about1} alt="About" />
                        </div>
                    </div>
                    <div className="col-lg-6 pb-5">
                        <div className="mb-3 pb-2">
                            <h6 className="text-primary text-uppercase">About Us</h6>
                            <h3>We are a prominent company specializing in the export of high-quality Egyptian
                                agricultural products, including fresh and frozen fruits and vegetables</h3>
                        </div>
                        <div className="row gx-5 gy-4">
                            <div className="col-sm-6" data-aos="fade-right" data-aos-delay="100">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>Fresh fruits </h4>
                            </div>

                            <div className="col-sm-6" data-aos="fade-left" data-aos-delay="150">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>Frozen fruits </h4>
                            </div>
                            <div className="col-sm-6" data-aos="fade-right" data-aos-delay="200">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>Fresh vegetables </h4>
                            </div>
                            <div className="col-sm-6" data-aos="fade-left" data-aos-delay="250">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>frozen vegetables</h4>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* About End */}

             {/* Features Start */}
             <div className="container-fluid bg-primary feature py-5 pb-lg-0 my-5">
            <div className="container py-5 pb-lg-0">
                <div className="mx-auto text-center mb-3 pb-2" style={{ maxWidth: "500px" }}>
                    <h6 className="text-uppercase text-secondary" data-aos="fade-up" data-aos-delay="100">Features</h6>
                    <h1 className="display-5 text-white" data-aos="fade-up" data-aos-delay="100">Why Choose Us</h1>
                </div>
                <div className="row g-5">
                    <div className="col-lg-3">
                        <div className="text-white mb-5" data-aos="fade-right" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">We can provide our customers with the best quality and best prices</h4>
                        </div>
                        <div className="text-white" data-aos="fade-right" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">We strive to satisfy our customers.</h4>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="d-block bg-white h-100 text-center p-5 pb-lg-0" data-aos="fade-up" data-aos-delay="100">
                            <h4>We can provide our customers with the best quality and best prices.</h4>
                            <h4>Our production comes from our own farms.</h4>
                            <img className="img-fluid" src={about2} alt="Feature" />
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="text-white mb-5" data-aos="fade-left" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">Our customer support team will provide our customers with all the assistance
                                required.</h4>
                        </div>
                        <div className="text-white" data-aos="fade-left" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">We have a variety of products.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* Features End */}

   </>
 }
 